import notification from "antd/lib/notification";
import "antd/lib/notification/style/index";

class Notification {
    success(title, text) {
        notification.success({
            message: <span style={{ color: "#0C9E42",fontWeight:"600",opacity:"0.8" }}>{title}</span>,
            description: <span style={{ color: "#0C9E42",fontWeight:"600",opacity:"0.8" }}>{text}</span>,
            duration: 3,
            style: {
                borderRadius: 11,
                backgroundColor: "#EDF9F0",
            },
        });
    }

    error(title, text) {
        notification.error({
            message: <span style={{ color: "#FF0606",fontWeight:"600",opacity:"0.8" }}>{title === 'error' ? 'Error!' : title}</span>,
            description: <span style={{ color: "#FF0606",fontWeight:"600",opacity:"0.8" }}>{text}</span>,
            duration: 5,
            style: {
                borderRadius: 11,
                backgroundColor: "#FEEFEF",
            },
        });
    }

    warning(title, text) {
        notification.warning({
            message: <span style={{ fontWeight:"600",opacity:"0.8" }}>{title}</span>,
            description: <span style={{ fontWeight:"600",opacity:"0.8" }}>{text}</span>,
            duration: 5,
            style: {
                borderRadius: 11,
                backgroundColor: "#FFF4EC",
            },
        });
    }
}

export default new Notification();